exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gaqxqHGx3yA_nFSXJqgiD a{color:dycolor-internal(!info-text,@theme-white)}\n", ""]);

// exports
exports.locals = {
	"root": "gaqxqHGx3yA_nFSXJqgiD"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/rabbit/landing-page/LandingPage.scss
// module id = 904
// module chunks = 1